<template>
    <div id="cb-entries">
        <div style="background-color: #ffffff" class="d-flex w-100">
            <div class="side-menubar-wrapper">
                <SideMenuBar />
            </div>
            <div class="content">
                <div class="send-message-container">
                    <a-alert :message="errorMessage" v-if="isError" type="error" show-icon />
                    <a-alert :message="saveMessage" v-if="isSave" type="success" show-icon />
                </div>
                <div class="entries-container">
                    <div class="header">
                        <div class="left">
                            <div class="title" @click="$router.push({ name: 'chatbot-entities' })">
                                {{ $t("chatbotv2.entities") }}
                                <md-icon>chevron_right</md-icon>
                            </div>
                            <div class="input-container">
                                <input :placeholder="$t('chatbotv2.entryName')" v-model="entitiesName" />
                            </div>
                        </div>
                        <div class="right">
                            <div class="button-container" @click="saveButtonClickHandler">
                                {{ $t("chatbotv2.save") }}
                            </div>
                        </div>
                    </div>
                    <div class="add-entries">
                        <div class="add-container">
                            <div class="subtitle">{{ $t("chatbotv2.entries") }}</div>
                            <div class="add-entries-button" @click="addEntryClickHandler">
                                <md-icon>add</md-icon>
                            </div>
                        </div>
                    </div>
                    <div class="entries-list">
                        <div class="entries-list-empty-text" v-if="entries.length < 1">
                            {{ $t("chatbotv2.youHaveNoEntries") }}
                        </div>
                        <div class="list-wrapper" v-if="entries.length > 0">
                            <EntriesListItem
                                v-for="(entry, index) in entries"
                                :key="`${entry.value}_${index}`"
                                :initial-data="entry"
                                :other-entry-names="
                                    entries.map((entry) => entry.value).filter((x) => x !== entry.value)
                                "
                                @delete-entry="deleteEntry(index)"
                                @update-entry="(args) => updateEntry(args, index)"
                                @error="sendError"
                                :open="openedEntryId === entry.value"
                                :on-opened="() => (openedEntryId = entry.value)"
                                :on-closed="() => (openedEntryId = null)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EntriesListItem from "./EntriesListItem";
import SideMenuBar from "../../SideMenuBar";
import { mapActions, mapMutations } from "vuex";
import { CHATBOT_API } from "../../../../../api/chatbotv2";

let timeoutIndex;

export default {
    name: "Entries",
    components: {
        EntriesListItem,
        SideMenuBar,
    },
    data() {
        return {
            entitiesName: "",
            entries: [],
            isUpdate: false,
            isError: false,
            isSave: false,
            errorMessage: "",
            saveMessage: "",
            itemsHasError: new Set(),
            openedEntryId: null,
        };
    },
    methods: {
        ...mapMutations({
            SET_LARGE_HEADER: "app/SET_LARGE_HEADER",
        }),
        checkEntriesIsValid() {
            const self = this;
            if (this.entries.length === 0) {
                return this.sendError("Must be at least one entry");
                return false;
            }
            for (let entry of this.entries) {
                if (entry.value.length == 0 || entry.synonyms.length < 1) {
                    // self.sendError(self.$t("chatbotv2.emptyError"));
                    console.error("Empty entry", self.$t("chatbotv2.emptyError"));
                    return false;
                }
                const otherEntryNames = self.entries.map((entry) => entry.value).filter((x) => x !== entry.value);
                const isUnique = !otherEntryNames.includes(entry.value);
                if (!isUnique) {
                    console.error("Duplicate entry");
                    // self.sendError(self.$t("chatbotv2.entryNamesMustBeUnique"));
                    return false;
                }
            }
            return true;
        },
        async saveButtonClickHandler() {
            if (!this.entitiesName || this.entitiesName.length === 0) {
                return this.sendError(this.$t("chatbotv2.entityNameCantBeEmpty"));
            }

            if (!this.checkEntriesIsValid()) {
                console.error("Entries are not valid");
                this.sendError("Entries are not valid");
                return;
            }
            if (this.isUpdate) {
                const response = await CHATBOT_API.updateEntity({
                    id: this.$route.params.id,
                    name: this.entitiesName,
                    entries: this.entries,
                }).then((x) => x.data);
                if (response.isSuccess === false) {
                    return this.sendError(this.$t("chatbotv2.entityNameMustBeUnique"));
                }
                this.sendSave(this.$t("chatbotv2.entityhasbeenUpdatedSuccessfully"));
                return;
            }
            const response = await CHATBOT_API.addEntities({ name: this.entitiesName, entries: this.entries }).then(
                (x) => x.data
            );
            if (response.isSuccess === false) {
                return this.sendError(this.$t("chatbotv2.entityNameMustBeUnique"));
            }
            this.sendSave(this.$t("chatbotv2.entityhasbeenUpdatedSuccessfully"));
        },
        updateEntry(entry, index) {
            this.$set(this.entries, index, entry);
            this.openedEntryId = entry.value;
        },
        deleteEntry(index) {
            this.entries = this.entries.filter((_, _index) => _index !== index);
        },
        sendError(message) {
            if (this.isError == true) {
                return;
            }
            if (timeoutIndex) {
                clearTimeout(timeoutIndex);
            }
            this.isError = true;
            this.errorMessage = message;
            timeoutIndex = setTimeout(() => {
                this.isError = false;
            }, 4000);
        },
        sendSave(message) {
            this.openedEntryId = null;
            if (timeoutIndex) {
                clearTimeout(timeoutIndex);
            }
            this.isError = false;
            this.isSave = true;
            this.saveMessage = message;
            timeoutIndex = setTimeout(() => {
                this.isSave = false;
            }, 4000);
        },
        addEntryClickHandler() {
            this.entries = [
                {
                    value: "",
                    synonyms: [],
                },
                ...this.entries,
            ];
        },
    },
    async mounted() {
        this.SET_LARGE_HEADER(false);
        if (this.$route.params.id) {
            const data = await CHATBOT_API.conditionalGetEntities({ id: this.$route.params.id }).then((x) => x.data);
            if (data) {
                this.entitiesName = data[0].name;
                this.entries = data[0].entries;
                this.isUpdate = true;
            }
        }
    },
    beforeDestroy() {
        this.SET_LARGE_HEADER(true);
    },
};
</script>
<style lang="scss">
#cb-entries {
    background-color: #f5f8fb;
    display: flex;
    height: auto;
    min-height: 100vh;
    display: flex;
    position: relative;

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;
    }

    .send-message-container {
        position: absolute;
        top: 10px;
        left: 600px;
        transition: 300ms;
    }

    .entries-container {
        padding: 20px 30px;
        width: 100%;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;

            .left {
                display: flex;
                width: 100%;
                margin-right: 40px;

                .title {
                    color: #22272d;
                    line-height: 31px;
                    font-size: 24px;
                    color: #516173;
                    font-weight: 400;
                    transition: color 200ms;
                    cursor: pointer;

                    i {
                        color: #516173;
                        margin: 0 !important;
                        font-variation-settings: "FILL" 0, "wght" 200, "GRAD" 0, "opsz" 48;
                    }

                    &:hover {
                        color: #008aff;

                        i {
                            color: #008aff;
                        }
                    }
                }

                .input-container {
                    margin-left: 10px;
                    width: 100%;
                    max-width: 500px;

                    input {
                        line-height: 31px;
                        font-size: 24px;
                        color: #22272d;
                        border: none;
                        font-weight: 300;
                        border-bottom: 1px solid #9ba6b3;
                        background-color: transparent;
                        outline: none;
                        transition: border-color 200ms;
                        width: 100%;

                        &::placeholder {
                            font-weight: 300;
                        }

                        &:focus {
                            border-color: #9ba6b3;
                        }
                    }
                }
            }

            .right {
                .button-container {
                    padding: 0 14px;
                    font-size: 16px;
                    font-weight: 400;
                    background-color: #006cff;
                    color: white;
                    border-radius: 4px;
                    cursor: pointer;
                    height: 37px;
                    min-width: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }

        .add-entries {
            .add-container {
                display: flex;
                align-items: center;
                margin-bottom: 30px;

                .subtitle {
                    font-weight: 300;
                    font-size: 18px;
                }

                .add-entries-button {
                    width: 30px;
                    height: 30px;
                    background-color: #008aff;
                    border-radius: 999px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-left: 10px;

                    i {
                        color: white;
                        font-size: 20px;
                    }

                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }

        .entries-list {
            .entries-list-empty-text {
            }

            add-new-entries {
                margin-bottom: 20px;
            }

            .list-wrapper {
            }
        }
    }
}
</style>
